<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Notification from "@/services/Notification";
import modalAddPushNotification from "@/components/modals/notification/modalAddPushNotification";
import Swal from "sweetalert2";

/**
 * Starter page
 */
export default {
  components: { Layout, PageHeader, modalAddPushNotification },
  page: {
    title: "Notifications",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
        title: "Push Notifications",
        items: [
            {
                text: "Push Notifications",
                href: "/",
            },
        ],
        isBusy: false,

        tableData: [], 
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: "age",
        sortDesc: false,
        fields: [
            {
              key: "notification_group",
              label: "Notification Id",
            },
            {
              key: "message",
              label: "Message",
            },
            {
              key: "recipient",
              label: "Recipient",
            },
            {
              key: "setup_datetime",
              label: "Scheduled",
            },
            {
              key: "initiated_datetime",
              label: "Initiated",
            },
            {
              key: "completed_datetime",
              label: "Completed",
            },
            {
              key: "success",
              label: "Success",
            },
            {
              key: "error",
              label: "Failed",
            },
            {
              key: "timestamp",
              label: "Created",
            },
            {
              key: "language",
              label: "Language",
            },
            "action",
        ],   
    };
  },
  middleware: "authentication",
  computed: {
      /**
       * Total no. of records
       */
      rows() {
        return this.tableData.length;
      },
  },
  mounted() {
      // Set the initial number of items
      this.totalRows = this.items.length;
  },
  created() {
     this.getNotifications()
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    async getNotifications(){
        try {
            this.toggleBusy();
            const response = await Notification.getNotifications()
            this.tableData = response.data.notifications;
            this.toggleBusy();
        } catch (error) {
            this.error = error.response.data.error ? error.response.data.error : "";
            this.tableData = []
        }
    },
    modalAddPushNotification() {
        this.$bvModal.show("add_new_push_notification");
    },

    getTimestamp: function () {
      return Math.floor(new Date().getTime() / 1000)
    },


    deleteNotification(notification_group_id) {
          Swal.fire({
              title: "Are you sure?",
              text: "This Bulk Notification will be deleted !",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Yes, delete it!",
          }).then((result) => {
              if (result.value) {
                    Notification.deleteNotification(notification_group_id)
                    .then((response) => {
                        const res = response.data.success ? response.data.success : false;
                        const error = response.data.error ? response.data.error : 'Failed';
                        if(res){
                            this.getNotifications();
                            Swal.fire("Removed!", "Bulk Notification Removed !", "success");
                        }else{
                            Swal.fire("Fail!", error, "warning");
                        }
                    })
                    .catch(error => {
                        this.getNotifications();
                        Swal.fire("Fail!", error, "warning");
                    });
              }
          });
    },


  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">

        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
                <div class="col-md-6">
                  <div class="mb-3">
                    <a  href="javascript:void(0);" class="btn btn-success waves-effect waves-light" @click="modalAddPushNotification">
                        <i class="mdi mdi-plus me-2"></i> 
                        Create New
                    </a>
                  </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                          Show&nbsp;
                          <b-form-select
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                          ></b-form-select
                          >&nbsp;entries
                      </label>
                      </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                      <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-end"
                      >
                      <label class="d-inline-flex align-items-center">
                          Search:
                          <b-form-input
                          v-model="filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ms-2"
                          ></b-form-input>
                      </label>
                      </div>
                  </div>
                  <!-- End search -->
                  </div>
                  <!-- Table -->
                  <b-table
                      :busy="isBusy"
                      table-class="table table-centered datatable table-card-list"
                      thead-tr-class="bg-transparent"
                      :items="tableData"
                      :fields="fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      show-empty
                      empty-text="No Data Found"
                      @filtered="onFiltered"
                    >
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(notification_group)="data">

                        <div  v-if="notification_group!=''">
                            <router-link :to="{ path: `/notifications/details?id=${data.item.notification_group}&type=group`}">
                                {{ data.item.notification_group }}
                            </router-link>
                        </div>
                        <div  v-else>
                            <router-link :to="{ path: `/notifications/details?id=${data.item.notification_id}&type=single`}">
                                {{ data.item.notification_id }}
                            </router-link>
                        </div>
                    </template>

                    <template v-slot:cell(action)="data">
                      <ul class="list-inline mb-0"  v-if="getTimestamp() < data.item.set_up">
                          <a href="javascript:void(0);" class="px-2 text-danger" v-b-tooltip.hover title="Delete" @click="deleteNotification(data.item.notification_group)">
                              <i class="uil uil-trash-alt font-size-18"></i>
                          </a>
                      </ul>
                    </template>

                    </b-table>

                  <div class="row">
                    <div class="col">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination pagination-rounded">
                          <!-- pagination -->
                          <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
        
    <!-- MODALS --> 
    <modalAddPushNotification 
        @refreshScreen="getNotifications" >
    </modalAddPushNotification>
    <!-- END  MODALS --> 

          

  </Layout>
</template>
